import React, { FC, useCallback } from 'react';
import ReactModal from 'react-modal';
import { enableScroll, disableScroll } from '@app/react/common/bodyScrollLock';

ReactModal.setAppElement('#ec-layoutRole__contents');

export interface PanelProps {
    children: React.ReactNode;
    isOpen: boolean;
    onRequestClose: () => void;
}

export const Panel: FC<PanelProps> = ({ children, isOpen, onRequestClose }) => {
    const onAfterOpen = useCallback(
        () => disableScroll(),
        [],
    );
    const onAfterClose = useCallback(
        () => enableScroll(),
        [],
    );

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            onAfterOpen={onAfterOpen}
            onAfterClose={onAfterClose}
            overlayClassName={{
                base: 'panel-overlay',
                afterOpen: 'panel-overlay--after-open',
                beforeClose: 'panel-overlay--before-close',
            }}
            className={{
                base: 'panel-modal',
                afterOpen: 'panel-modal--after-open',
                beforeClose: 'panel-modal--before-close',
            }}
            closeTimeoutMS={300}
            parentSelector={() => document.querySelector('#modal-root') as HTMLElement}
        >
            {children}
        </ReactModal>
    );
};
